import React from 'react'
import { listSliders } from './config/listSliders'
import {
  initChiefSlider,
  Slide,
  SlidesCarousel
} from './shared'


class ChiefSliderComponent extends React.Component {
  componentDidMount() {
    listSliders
      && listSliders.length > 1
      && initChiefSlider()
  }

  render() {
    return (
      <div className='max-width-1360 m-auto'>
        {listSliders.length === 1 && <Slide s={listSliders[0]} i={0} />}
        {listSliders.length > 1 && <SlidesCarousel listSliders={listSliders} />}
      </div>
    )
  }
}

export default ChiefSliderComponent



// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/index.jsx